import { createStore } from 'vuex';
import { config } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/AuthModule';
import BodyModule from '@/store/modules/BodyModule';
import BreadcrumbsModule from '@/store/modules/BreadcrumbsModule';
import MenuModule from './modules/MenuModule';
import ConfigModule from '@/store/modules/ConfigModule';
import ErrorHandleModule from './modules/ErrorHandleModule';
import PbiEmbeddedModule from './modules/PbiEmbeddedModule';
import MasterSchemaListModule from './modules/hrgs/master/schema/MasterSchemaListModule';
import MasterSchemaPostModule from './modules/hrgs/master/schema/MasterSchemaPostModule';
import AssetCategoryModule from './modules/finance/AssetCategoryModule';
import MainCategoryModule from './modules/finance/MainCategoryModule';
import GroupModule from './modules/finance/GroupModule';
import AssetProfillingClassModule from './modules/finance/AssetProfillingClassModule';
import AssetProfillingModule from './modules/finance/AssetProfillingModule';
import HierarchyModule from './modules/finance/HierarchyModule';
import BudgetCatalogModule from './modules/finance/BudgetCatalogModule';
import AssetNumberModule from './modules/finance/AssetNumberModule';
import ProfitCenterModule from './modules/finance/ProfitCenterModule';
import MappingProfillingModule from './modules/finance/MappingProfillingModule';
import FunctionModule from './modules/finance/FunctionModule';
import DirectorateModule from './modules/finance/DirectorateModule';
import DivisionModule from './modules/finance/DivisionModule';
import DepartmentModule from './modules/finance/DepartmentModule';
import WbsModule from './modules/finance/WbsModule';
import MappingProjectModule from './modules/finance/MappingProjectModule';
import DefineCurrentVersionModule from './modules/finance/DefineCurrentVersionModule';
import BudgetSummaryModule from './modules/finance/BudgetSummaryModule';
import ExportModule from './modules/finance/ExportModule';
import AssessorModule from './modules/hrgs/master/AssessorModule';
import CrfListModule from './modules/pscm/requisition/CrfListModule';
import JciListModule from './modules/pscm/requisition/JciListModule';
import FpkListModule from './modules/pscm/requisition/FpkListModule';
import CrfModule from './modules/pscm/requisition/CrfModule';
import CrfDetailModule from './modules/pscm/requisition/CrfDetailModule';
import CrfApprovalModule from './modules/pscm/requisition/CrfApprovalModule';
import TaskRequisitionModule from './modules/pscm/requisition/TaskrequisitionModule';
import PurchaseInquiryModule from './modules/pscm/requisition/PurchaseInquiryModule';
import AnswerTypeModule from './modules/hrgs/AnswerTypeModule';
import SchemaModule from './modules/hrgs/master/SchemaModule';
import PositionModule from './modules/hrgs/master/PositionModule';
import UserModule from './modules/hrgs/master/UserModule';
import TukModule from './modules/hrgs/master/TukModule';
import CompetencyUnitModule from './modules/hrgs/master/CompetencyUnitModule';
import MasterPreAssessmentModule from './modules/hrgs/master/PreAssessmentScheduleModule';
import FormBuilderModule from './modules/hrgs/master/FormBuilderModule';
import AssessmentModule from './modules/hrgs/master/AssessmentModule';
import DataSourceModule from './modules/hrgs/DataSourceModule';
import CompetencyMappingModule from './modules/hrgs/master/CompetencyMappingModule';
import UploadModule from './modules/hrgs/UploadModule';
import ApprovalHistoryModules from './modules/hrgs/assessment/ApprovalHistoryModules';
import TravelokaTransactionModule from './modules/hrgs/TravelokaTransactionModule';
import FinanceModule from './modules/finance/FinanceModule';
import ReportModule from './modules/hrgs/dashboard/ReportModule';
import DashboardHrgsModule from './modules/hrgs/dashboard/DashboardModule';
import NotificationModule from './modules/NotificationModule';
import popupMasterModule from './modules/pscm/migo/popupMasterModule';
import pscmCompModule from './modules/pscm/pscmCompModule';
import GeneralMigo from './modules/pscm/migo/GeneralMigo';
import transactionModule from './modules/pscm/migo/transactionModule';
import transactionListModule from './modules/pscm/migo/transactionListModule';
import PscmReportingModule from './modules/pscm/reporting/PscmReportingModule';
import transactionGiModule from './modules/pscm/migo/transactionGiModule';
import transactionTpModule from './modules/pscm/migo/transactionTpModule';
config.rawError = true;
const store = createStore({
    modules: {
        AuthModule,
        BodyModule,
        BreadcrumbsModule,
        MenuModule,
        ConfigModule,
        ErrorHandleModule,
        PbiEmbeddedModule,
        MasterSchemaListModule,
        MasterSchemaPostModule,
        AssetCategoryModule,
        MainCategoryModule,
        GroupModule,
        AssetProfillingClassModule,
        AssetProfillingModule,
        HierarchyModule,
        BudgetCatalogModule,
        AssetNumberModule,
        ProfitCenterModule,
        MappingProfillingModule,
        FunctionModule,
        DirectorateModule,
        DivisionModule,
        DepartmentModule,
        WbsModule,
        MappingProjectModule,
        DefineCurrentVersionModule,
        BudgetSummaryModule,
        ExportModule,
        CrfListModule,
        JciListModule,
        CrfModule,
        FpkListModule,
        CrfDetailModule,
        CrfApprovalModule,
        TaskRequisitionModule,
        PurchaseInquiryModule,
        AnswerTypeModule,
        SchemaModule,
        PositionModule,
        UserModule,
        TukModule,
        CompetencyUnitModule,
        MasterPreAssessmentModule,
        FormBuilderModule,
        AssessmentModule,
        DataSourceModule,
        AssessorModule,
        CompetencyMappingModule,
        UploadModule,
        ApprovalHistoryModules,
        TravelokaTransactionModule,
        FinanceModule,
        ReportModule,
        DashboardHrgsModule,
        NotificationModule,
        popupMasterModule,
        pscmCompModule,
        GeneralMigo,
        transactionModule,
        transactionListModule,
        PscmReportingModule,
        transactionGiModule,
        transactionTpModule
    }
});
export default store;
